import React from "react";
import { PageHeader } from "@/components/common";
import OralChampionSection from "@/components/OralChampionSection";
import { ChampionBadge } from "@/components/ChampionBadge";
import { UpcomingWebinars } from "@/components/UpcomingWebinars";
import { ChampionCertificate } from "@/components/ChampionCertificate";

export default function LiveSessions() {
  return (
    <div data-testid="oral-champion-page">
      <PageHeader
        title="Oral Champion"
        subtitle="Register one member of your team for the live Oral Champion course — included in your subscription."
      />
      <ChampionBadge editable />
      <ChampionCertificate />
      <UpcomingWebinars />
      <div className="rounded-2xl border border-cream-deep bg-cream-card p-6 md:p-8">
        <span className="label-caps text-coral">Included in your subscription · 3-hour live course</span>
        <h2 className="font-heading font-bold text-brand text-2xl md:text-3xl mt-2">Register your Oral Champion</h2>
        <p className="text-muted-foreground mt-3 max-w-2xl">
          One member of your team can train as your Oral Champion each year — included in your subscription.
          CQC's Smiling Matters report recommends an Oral Champion in every care home.
        </p>
        <OralChampionSection showTestimonials={false} />
      </div>
    </div>
  );
}
